import { Icon } from '@chakra-ui/react';
import React from 'react';

const Help = props => {
  return (
    <Icon
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6668 8.16667C16.6668 6.39856 15.9644 4.70286 14.7142 3.45262C13.464 2.20238 11.7683 1.5 10.0002 1.5C8.23205 1.5 6.53636 2.20238 5.28612 3.45262C4.03588 4.70286 3.3335 6.39856 3.3335 8.16667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 14V14.4167C16.6667 14.8587 16.4912 15.2827 16.1786 15.5952C15.866 15.9078 15.4421 16.0834 15.0001 16.0834H12.0834M1.66675 11.865V10.3017C1.6668 9.93005 1.79108 9.56907 2.01984 9.27615C2.24859 8.98323 2.56868 8.77517 2.92925 8.68504L4.37925 8.32171C4.45293 8.30336 4.52982 8.30203 4.60409 8.31782C4.67836 8.33362 4.74806 8.36612 4.80789 8.41286C4.86773 8.45961 4.91613 8.51937 4.94943 8.58761C4.98273 8.65585 5.00005 8.73077 5.00008 8.80671V13.3592C5.00021 13.4353 4.98298 13.5104 4.94968 13.5788C4.91639 13.6473 4.86792 13.7072 4.80797 13.754C4.74801 13.8009 4.67815 13.8334 4.60371 13.8492C4.52928 13.865 4.45222 13.8636 4.37841 13.845L2.92841 13.4825C2.568 13.3923 2.2481 13.1841 2.01951 12.8912C1.79092 12.5983 1.66676 12.2374 1.66675 11.8659V11.865ZM18.3334 11.865V10.3017C18.3334 9.93005 18.2091 9.56907 17.9803 9.27615C17.7516 8.98323 17.4315 8.77517 17.0709 8.68504L15.6209 8.32171C15.5472 8.30336 15.4703 8.30203 15.3961 8.31782C15.3218 8.33362 15.2521 8.36612 15.1923 8.41286C15.1324 8.45961 15.084 8.51937 15.0507 8.58761C15.0174 8.65585 15.0001 8.73077 15.0001 8.80671V13.3592C15 13.4352 15.0172 13.5102 15.0505 13.5786C15.0837 13.6469 15.1321 13.7068 15.1919 13.7536C15.2518 13.8005 15.3215 13.833 15.3959 13.8489C15.4702 13.8647 15.5472 13.8634 15.6209 13.845L17.0709 13.4825C17.4315 13.3924 17.7516 13.1844 17.9803 12.8914C18.2091 12.5985 18.3334 12.2375 18.3334 11.8659V11.865Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.25 17.3334H8.75C8.41848 17.3334 8.10054 17.2017 7.86612 16.9673C7.6317 16.7328 7.5 16.4149 7.5 16.0834C7.5 15.7519 7.6317 15.4339 7.86612 15.1995C8.10054 14.9651 8.41848 14.8334 8.75 14.8334H11.25C11.5815 14.8334 11.8995 14.9651 12.1339 15.1995C12.3683 15.4339 12.5 15.7519 12.5 16.0834C12.5 16.4149 12.3683 16.7328 12.1339 16.9673C11.8995 17.2017 11.5815 17.3334 11.25 17.3334Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </Icon>
  );
};

export default Help;
